import { render } from "./TutorialDetails.vue?vue&type=template&id=5d568b5e"
import script from "./TutorialDetails.vue?vue&type=script&lang=js"
export * from "./TutorialDetails.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\manzurul\\AppData\\Local\\Jenkins.jenkins\\workspace\\Eznatal-Support-Production\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__